import {CardTitle} from "../ui/card";
import {useNavigate} from "react-router-dom";
import {Notification} from "@models/notification_model";
import { dateFormatter } from "../../lib/formatters";

type notificationWidgetProps = {
    notifications: Notification[];
};

export function NotificationPWidget({notifications}: notificationWidgetProps) {

    const navigate = useNavigate();

    return <div className="text-center text-sm">
        <CardTitle>Latest Activity</CardTitle>

        {notifications.length > 0 ? (
            <div className="mt-4">
                <table className="table-auto w-full">
                    <thead>
                    <tr>
                        {/*<th className="px-4 py-2 text-left">Topic</th>*/}
                        <th className="px-4 py-2 text-left">Message</th>
                        <th className="px-4 py-2 text-left">Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {notifications.map((notification) => (
                        <tr
                            key={notification._id}
                            className="border-t border-b"
                        >
                            {/*<td className="px-4 py-2 text-left">*/}
                            {/*    {notification.notification[0].tool}*/}
                            {/*</td>*/}
                            <td className="px-4 py-2 text-left">
                                <p
                                    className="font-medium text-gray-600 hover:text-gray-900 hover:scale-105 transition-all duration-300 cursor-pointer"
                                    onClick={() => navigate(notification.notification[0].url)}
                                >
                                    {notification.notification[0].message}
                                </p>
                            </td>
                            <td>
                                {dateFormatter.format(new Date(notification.notification[0].created_at))}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        ) : (
            <p className="text-left">No latest activity</p>
        )}
    </div>
}
